import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'

/**
 * Applies one comment across the Space records selected in the records list.
 */
@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.input.textArea.Component,
    ds.layout.widget.Component,
    ds.notice.Component,
    ds.overlay.centered.Component,
  ],
  selector: 'atn-space-bulk-comment-modal',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.space.full.records.Collection} */
  public readonly recordsEc = ngCore.inject(state.space.full.records.Collection)

  /** @see {@link state.space.full.records.plugins.bulkComment.Plugin} */
  public readonly bulkCommentPlugin = this.recordsEc.plugins
    .lookup(state.space.full.records.plugins.bulkComment.Plugin)
    .get()

  /** @see {@link ents.core.display.Style} */
  public readonly DisplayStyle = ents.core.display.Style

  /** Modal title, naming how many records the comment will be applied to */
  public readonly titleSg = ngCore.computed(
    (
      recordCount = this.recordsEc.plugins.selectionPlugin.feature.selectors
        .getAllSelectedIds({
          target: state.space.full.records.SPACE_RECORDS_SELECTION_TARGET,
        })
        .asSignal().length,
    ) =>
      `Update Comment (${recordCount} Space ${
        recordCount === 1 ? 'Record' : 'Records'
      } selected)`,
  )

  /** Stores the edited comment */
  public commentChangedHandler(comment: string | undefined): void {
    this.bulkCommentPlugin.actions.setComment
      .from('Space.BulkComment.Modal.Comment.Inputted')
      .dispatch(comment ?? '')
  }

  /** Applies the comment to every selected record */
  public saveClickHandler(): void {
    this.bulkCommentPlugin.actions.submit
      .from('Space.BulkComment.Modal.SaveButton.Clicked')
      .dispatch()
  }

  /** Closes the modal without applying anything */
  public cancelClickHandler(): void {
    this.bulkCommentPlugin.actions.cancel
      .from('Space.BulkComment.Modal.CancelButton.Clicked')
      .dispatch()
  }
}
